import { Link, useLocation } from 'react-router-dom'
import { Home, Car, Map, Newspaper, User } from 'lucide-react'
import { useAuthStore, useLanguageStore } from '../../lib/store'

export default function MobileNavbar() {
    const location = useLocation()
    const { isAuthenticated } = useAuthStore()
    const { language } = useLanguageStore()

    const navItems = [
        { path: '/', icon: Home, label: { en: 'Home', vi: 'Trang chủ' } },
        { path: '/vehicles', icon: Car, label: { en: 'Vehicles', vi: 'Xe' } },
        { path: '/tours', icon: Map, label: { en: 'Tours', vi: 'Tour' } },
        { path: '/blog', icon: Newspaper, label: { en: 'Blog', vi: 'Blog' } },
        { path: isAuthenticated ? '/dashboard' : '/login', icon: User, label: { en: 'Account', vi: 'Tài khoản' } },
    ]

    const isActive = (path: string) => {
        if (path === '/') return location.pathname === '/'
        return location.pathname.startsWith(path)
    }

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 lg:hidden safe-bottom">
            <div className="flex items-center justify-around h-16">
                {navItems.map((item) => {
                    const Icon = item.icon
                    const active = isActive(item.path)

                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex flex-col items-center justify-center flex-1 h-full transition ${active ? 'text-primary-600' : 'text-gray-500'
                                }`}
                        >
                            <Icon className={`w-5 h-5 ${active ? 'scale-110' : ''} transition-transform`} />
                            <span className="text-xs mt-1">{item.label[language]}</span>
                            {active && (
                                <div className="absolute bottom-0 w-12 h-1 bg-primary-600 rounded-t-full" />
                            )}
                        </Link>
                    )
                })}
            </div>
        </nav>
    )
}
